module.exports = __webpack_public_path__ + "img/cancel-anytime.952577e7.png";